/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-10-26, 11:38:36
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2017-11-07, 15:09:02
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'HeaderLogo',
};



// WEBPACK FOOTER //
// ./src/components/Panel/HeaderContainer/HeaderLogo/component.js